<template>
  <div class="ChangePertnerMultiple" ref="base">
    <template v-if="trigger">
      <multiple-partner-list
        class="listwrap"
        :partner-list="partnerList"
        :from-playlist="true"
        @to-detail="toDetail"
        @close="cancelChangePartner"
        @change-current="changeCurrent"
        />
    </template>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import MultiplePartnerList from '@/utvStore/components/MultiplePartnerList'


export default {
  name: 'ChangePertnerMultiple',
  components:{
    MultiplePartnerList
  },
  props: {
    partnerList:{
      type: Array,
      default: () => []
    },
    trigger: {
      type: Boolean,
      default: false
    },
    closeTrigger: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      buttonIsDisabled: false,
      isShowForm: false,
    }
  },
  watch:{
    trigger(val) {
      if (val) {
        this.base.classList.add('enabled')
        this.base.addEventListener('transitionend', this.onOpenComplete)
        setTimeout(() => this.base.classList.add('open'), 100)
        window.scrollTo(0, 0)
      }
    },
    closeTrigger(val) {
      if (val) this.closeDetail()
    },
  },
  computed: {
    ...mapState({
      accessToken: state => state.auth.accessToken
    }),
  },
  mounted(){
    this.base = this.$refs.base
  },
  methods: {
    toDetail(friendId){
      this.$emit('to-detail', friendId)
    },
    changeCurrent(){
      this.$emit('change-current')
    },
    cancelChangePartner(){
      this.$emit('cancel-change')
    },
    closeDetail() {
      this.base.classList.remove('open')
      this.base.addEventListener('transitionend', this.onCloseComplete)
    },
    onOpenComplete() {
      this.base.removeEventListener('transitionend', this.onOpenComplete)
    },
    onCloseComplete() {
      this.base.removeEventListener('transitionend', this.onCloseComplete)
      this.base.classList.remove('enabled')
      this.base.classList.remove('open')
      this.$emit('close-complete')
    },
  }
}</script>

<style lang="scss">
@import "../../../../sass/commons/commonVariables.scss";
.ChangePertnerMultiple{
  color: $col_base_black;
  padding: 44px 0px 50px;
  width: 100%;
  height: 100%;
  position: fixed;
  left: 100%;
  transition: transform 200ms ease-out 0s;
  background: $col_verylite_gray;
  display: none;
  top: 0;

  .listwrap{
    overflow: scroll;
    height: 100%;
    min-height: 100%;
    background: url('/static/img/common/background/bg_def_moya1.jpg') no-repeat,
      url('/static/img/common/background/bg_def_moya2.jpg') no-repeat;
    background-size: 100% auto, 100% auto;
    background-position: 0 0, 100% calc(100% - 20px);
    background-color: #fff;
  }

  .wrapper {
    width: 100%;
    height: 100%;
    position: relative;
    overflow-x: hidden;
    overflow-y: auto;
  }

  &.enabled {
    display: block;
  }

  &.open {
    transform: translate3d(-100%, 0, 0);
  }


}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/partials/ChangePartnerMultiple.vue